import '@firebase/storage-compat';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/compat/storage/dist/index.esm.js
// module id = 581
// module chunks = 14